<template>
  <div class="acs-purchasepopup-container">
    <div class="acs-purchasepopup-card">
      <h2>ACS补购查询</h2>
      <div class="acs-purchasepopup-form">
        <div>补购编号</div>
        <el-input v-model="order_id" placeholder="请输入"></el-input>
        <el-button type="primary" class="search-btn" @click="handleSearch">查询</el-button>
      </div>
    </div>
    <div class="acs-purchasepopup-info" v-if="info">
      <el-form class="comp-detail-dialog" label-width="100px">
        <el-form-item label="状态" style="margin-bottom: 10px;">
          <div class="right">
            <el-link :type="bindStatus[info.bind_status].type">{{ info.bind_status_cn }}</el-link>
          </div>
        </el-form-item>
        <div class="reason" v-if="info.bind_status == 'BIND_FAIL' || info.bind_status == 'UNBIND_FAIL'">
          <div>失败原因：</div>
          <div>{{ info.bind_fail_reason }}</div>
        </div>
        <el-form-item label="补购编号">
          <div class="right">{{ info.order_id }}</div>
        </el-form-item>
        <el-form-item label="保障名称">
          <div class="right">{{ info.item_info.item_name }}</div>
        </el-form-item>
        <el-form-item label="补购金额">
          <div class="right">￥{{ info.total_fee / 100 }}</div>
        </el-form-item>
        <el-form-item label="绑定时间">
          <div class="right">{{ info.pay_time ? formatTimeStampToStr(info.pay_time) : '-' }}</div>
        </el-form-item>
        <el-form-item label="退款状态" style="margin-bottom: 10px;"
          v-if="info.bind_status == 'UNBIND' || info.bind_status == 'BIND_FAIL' || info.bind_status == 'UNBIND_FAIL'">
          <div class="right">
            <el-link :type="refundStatus[info.refund_status].type">{{ refundStatus[info.refund_status].value
              }}</el-link>
          </div>
        </el-form-item>
        <div class="reason" v-if="info.refund_status == 'REFUND_FAIL'">
          <div>失败原因：</div>
          <div>{{ info.refund_fail_reason }}</div>
        </div>
        <el-divider />
        <el-form-item label="设备信息" style="font-weight: bold;"></el-form-item>
        <el-form-item label="订单编号">
          <div class="right">{{ info.bind_order }}</div>
        </el-form-item>
        <el-form-item label="绑定设备">
          <div class="right">{{ info.bind_item }}</div>
        </el-form-item>
        <el-form-item label="设备序列号">
          <div class="right">{{ info.bind_item_sn }}</div>
        </el-form-item>
        <el-form-item label="购买平台">
          <div class="right">{{ info.bind_platform }}</div>
        </el-form-item>
        <el-form-item label="购买门店">
          <div class="right">{{ info.shop_name }}</div>
        </el-form-item>
      </el-form>
      <el-divider />
      <div class="acs-purchasepopup-info-action">
        <el-row>
          <el-button v-if="info.btns.refund" type="primary" @click="handleChange('退款', 'refund')">操作退款</el-button>
          <el-button v-if="info.btns.bind" type="success" @click="handleChange('绑定', 'bind')">请求绑定</el-button>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { getAcsDetailData, onAcsOption } from './api'
import { formatTimeStampToStr } from '@/utils/index'

export default {
  data() {
    return {
      type: '1',
      order_id: '',
      info: null,
      refundStatus: {
        "NO_APPLY_REFUND": {type: 'info', value: '未申请退款'},
        "REFUND_SUCCESS": {type: 'success', value: '退款成功'},
        "REFUND_FAIL": {type: 'danger', value: '退款失败'},
        "REFUND_CLOSE": {type: 'info', value: '退款关闭'},
        "REFUNDING": {type: 'info', value: '退款中'}
      },
      bindStatus: {
        "NOBIND": { type: 'info', value: '未绑定'},
        "BINDING": { type: 'info', value: '绑定中'},
        "BIND_SUCCESS": { type: 'success', value: '绑定成功'},
        "BIND_FAIL": { type: 'danger', value: '绑定失败'},
        "NOBINDIND": { type: 'info', value: '解绑中'},
        "UNBIND_FAIL": { type: 'danger', value: '解绑失败'},
        "UNBIND": { type: 'info', value: '已解绑'},
      }
    }
  },
  methods: {
    async handleSearch() {
      let params = { order_id: this.order_id }
      if(!this.order_id) {
        this.$message.error('请输入补购编号')
        return
      }
      const res = await getAcsDetailData(params)
      const { data } = res.data
      if(data.code == 400) {
        this.info = null
        this.$message.error('未查询到相关信息')
      } else {
        this.info = data
      }
    },
    handleChange(type, op) {
      this.$confirm('确定操作'+type+'?', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await onAcsOption({ order_id: this.info.order_id, op: op })
          this.$message.success('操作成功')
        } catch (err) {
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    formatTimeStampToStr(timeStamp) {
      // 时间戳转时间字符串
      var date = new Date()
      date.setTime(timeStamp * 1000)
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? '0' + m : m
      var d = date.getDate()
      d = d < 10 ? '0' + d : d
      var h = date.getHours()
      h = h < 10 ? '0' + h : h
      var minute = date.getMinutes()
      var second = date.getSeconds()
      minute = minute < 10 ? '0' + minute : minute
      second = second < 10 ? '0' + second : second
      return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second
    }
  }
}
</script>

<style lang="scss" scoped>
.acs-purchasepopup-container {
  .reason {
    font-size: 12px;
    margin: 0px 30px 20px;
    padding: 15px 20px;
    background: #f5f5f5;
    border-radius: 8px;
  }
  .el-form-item__content {
    .right {
      margin-right: 50px;
      text-align: right;
    }
  }
  display: flex;
  justify-content: space-around;
  padding: 24px;

  .acs-purchasepopup-card {
    margin-top: 48px;
    width: 40%;
    h2 {
      text-align: center;
      font-size: 34px;
    }
  }

  .acs-purchasepopup-form {
    margin: 24px 0px;
    .search-btn {
      width: 100%;
      margin: 24px 0;
    }
  }

  .acs-purchasepopup-info {
    width: 45%;
    background-color: #f5f5f7;
    padding: 24px;
    border-radius: 12px;
    h4 {
      font-weight: 600;
      color: #676a6e;
    }
    .info-item {
      display: flex;
      justify-content: space-between;
      margin: 24px 0;
      .info-item-status {
        color: #1480e3;
      }
    }
    &-action {
      margin-top: 24px;
      display: flex;
      justify-content: space-between;
    }
    &-tips {
      margin-top: 24px;
      color: red;
    }
  }
}
</style>
